/* ============================================================
   เมนูที่ปักหมุดไว้ของแต่ละผู้ใช้งาน
   - เก็บใน cookie แยกตาม userId อายุ 365 วัน
   - เก็บสูงสุด 8 รายการ เรียงตามลำดับที่ปักหมุด
============================================================ */
const MAX_PIN = 8;
const DAYS = 365;

const keyOf = (userId) => `nsf_pinned_${userId || "guest"}`;

const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const hit = (document.cookie ? document.cookie.split("; ") : []).find((c) =>
    c.startsWith(`${name}=`)
  );
  return hit ? decodeURIComponent(hit.split("=").slice(1).join("=")) : "";
};

const writeCookie = (name, value) => {
  if (typeof document === "undefined") return;
  const expires = new Date(Date.now() + DAYS * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; SameSite=Lax`;
};

export const getPinned = (userId) => {
  try {
    const raw = readCookie(keyOf(userId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.slice(0, MAX_PIN) : [];
  } catch (e) {
    return [];
  }
};

export const isPinned = (userId, to) =>
  getPinned(userId).some((p) => p.to === to);

/* ปัก/ถอนหมุด แล้วคืนรายการใหม่ */
export const togglePin = (userId, item) => {
  if (!item || !item.to) return getPinned(userId);
  const list = getPinned(userId);
  const found = list.some((p) => p.to === item.to);
  const next = found
    ? list.filter((p) => p.to !== item.to)
    : [...list, { title: item.title, to: item.to }].slice(0, MAX_PIN);
  writeCookie(keyOf(userId), JSON.stringify(next));
  return next;
};

export const PIN_LIMIT = MAX_PIN;
